// extracted by mini-css-extract-plugin
export default {"Tag":"Tag_Tag__r9eqk","Icon":"Tag_Icon__Aa3Hp"};